export function buildEmailTemplatesTableModel(rows) {
  return rows
    .map((row, index) => ({
      key: String(row?.id || `${row?.name || 'email-template'}-${row?.language || index}`),
      id: String(row?.id || ''),
      name: String(row?.name || ''),
      language: String(row?.language || '').toLowerCase(),
      subject: String(row?.subject || ''),
      html: String(row?.html || ''),
    }))
    .sort((a, b) => {
      const byName = a.name.localeCompare(b.name);
      if (byName !== 0) {
        return byName;
      }

      return a.language.localeCompare(b.language);
    });
}

export function validateEmailTemplateForm(form) {
  const errors = {};
  const name = String(form?.name || '').trim();
  const language = String(form?.language || '').trim().toLowerCase();
  const subject = String(form?.subject || '').trim();
  const html = String(form?.html || '').trim();

  if (!name) {
    errors.name = 'This field is required.';
  }

  if (!language) {
    errors.language = 'This field is required.';
  } else if (!/^[a-z]{2}$/i.test(language)) {
    errors.language = 'Use 2-letter ISO code.';
  }

  if (!subject) {
    errors.subject = 'This field is required.';
  }

  if (!html) {
    errors.html = 'This field is required.';
  }

  return errors;
}

export function normalizeTemplateHtmlPlaceholders(sourceHtml) {
  const html = String(sourceHtml || '');

  return html.replace(/\{\{([\s\S]*?)\}\}/g, (_match, inner) => {
    const normalizedInner = String(inner || '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\u00a0/g, ' ');

    return `{{${normalizedInner}}}`;
  });
}

export function normalizeTemplateHtmlWhitespace(sourceHtml) {
  const html = String(sourceHtml || '');
  return html
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00a0/g, ' ');
}

export function normalizeTemplateHtmlForSave(sourceHtml) {
  return normalizeTemplateHtmlPlaceholders(normalizeTemplateHtmlWhitespace(sourceHtml));
}
